import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';
import AGREGAR_AUDITORIA_ETIQUETAS from '@/graphql/mutations/administracion/auditorias/etiquetas/agregarAuditoriaEtiquetas.gql';
import REMOVER_AUDITORIA_ETIQUETA from '@/graphql/mutations/administracion/auditorias/etiquetas/removerAuditoriaEtiqueta.gql';

export default {
  apollo: {
    catalogoAuditoriaEtiquetas: {
      query: CATALOGO_AUDITORIA_ETIQUETAS,
    },
  },
  methods: {
    async mixGuardarEtiquetas() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_ETIQUETAS,
          variables: {
            idReferencia: this.idReferencia,
            auditoriaEtiquetas: this.getIdsEtiquetasSeleccionadas,
          },
          update: (store, { data: { agregarAuditoriaEtiquetas } }) => {
            this.etiquetasAgregadas.push(...agregarAuditoriaEtiquetas);
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
    async mixEliminarEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: REMOVER_AUDITORIA_ETIQUETA,
          variables: {
            id: this.etiquetaEliminar.id,
          },
          update: () => {
            const index = this.etiquetasAgregadas
              .findIndex(({ id }) => id === this.etiquetaEliminar.id);
            if (index !== -1) {
              this.etiquetasAgregadas.splice(index, 1);
            }
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  computed: {
    mixGetEtiquetas() {
      if (!this.catalogoAuditoriaEtiquetas) return [];
      const etiquetasExistentes = this.etiquetasAgregadas
        .map(({ idAuditoriaEtiqueta }) => idAuditoriaEtiqueta);
      return this.catalogoAuditoriaEtiquetas
        .filter(({ id }) => etiquetasExistentes.includes(id) === false);
    },
  },
};
